exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2CI__araY4C94OAnkGP8Fv {\n    margin-bottom: 24px;\n    margin-bottom: 1.5rem;\n}\n\n._158AUimPZVUE217-1MuDQx {\n    margin-left: 32px;\n    margin-left: 2rem;\n}\n\n._158AUimPZVUE217-1MuDQx p {\n    margin-top: 0;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_2CI__araY4C94OAnkGP8Fv",
	"description": "_158AUimPZVUE217-1MuDQx"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/FieldView.css
 ** module id = 24
 ** module chunks = 0
 **/